<div class="modal-header">
  <h4 class="modal-title">Facturación Electrónica Lubrikuv</h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss('Cross click')"></button>
</div>

<div class="modal-body">
  <form [formGroup]="form">
    
    <!-- Campos Ocultos (IDs) -->
    <input type="hidden" formControlName="id">
    <input type="hidden" formControlName="empresa_id">

    <!-- SECCIÓN 1: DATOS DE LA EMPRESA -->
    <h6 class="text-primary fw-bold mb-3">Datos de la Empresa</h6>
    <div class="row g-3 mb-4">
      
      <!-- RUT -->
      <div class="col-12 col-md-6">
        <label for="rut" class="form-label">RUT Empresa</label>
        <input type="text" id="rut" class="form-control" formControlName="rut"
          [ngClass]="{'is-invalid': form.get('rut')?.invalid && form.get('rut')?.touched}">
        <div class="invalid-feedback">
          Debe ingresar un RUT válido
        </div>
      </div>

      <!-- Nombre o Razón Social -->
      <div class="col-12 col-md-6">
        <label for="nombre_o_razonSocial" class="form-label">Nombre o Razón Social</label>
        <input type="text" id="nombre_o_razonSocial" class="form-control" formControlName="nombre_o_razonSocial"
          [ngClass]="{'is-invalid': form.get('nombre_o_razonSocial')?.invalid && form.get('nombre_o_razonSocial')?.touched}">
        <div class="invalid-feedback">
          Debe ingresar la razón social
        </div>
      </div>

      <!-- Giro Comercial -->
      <div class="col-12 col-md-6">
        <label for="giro_comercial" class="form-label">Giro Comercial</label>
        <input type="text" id="giro_comercial" class="form-control" formControlName="giro_comercial"
          [ngClass]="{'is-invalid': form.get('giro_comercial')?.invalid && form.get('giro_comercial')?.touched}">
        <div class="invalid-feedback">
          Debe ingresar el giro comercial
        </div>
      </div>

      <!-- Actividades Económicas -->
      <div class="col-12 col-md-6">
        <label for="actividades_economicas" class="form-label">Actividades Económicas</label>
        <input type="text" id="actividades_economicas" class="form-control" formControlName="actividades_economicas"
          [ngClass]="{'is-invalid': form.get('actividades_economicas')?.invalid && form.get('actividades_economicas')?.touched}">
        <div class="invalid-feedback">
          Debe ingresar las actividades económicas
        </div>
      </div>

    </div>

    <!-- SECCIÓN 2: UBICACIÓN Y CONTACTO -->
    <h6 class="text-primary fw-bold mb-3">Ubicación y Contacto Comercial</h6>
    <div class="row g-3 mb-4">

      <!-- Región -->
      <div class="col-12 col-md-4">
        <label for="region" class="form-label">Región</label>
        <input type="text" id="region" class="form-control" formControlName="region"
          [ngClass]="{'is-invalid': form.get('region')?.invalid && form.get('region')?.touched}">
        <div class="invalid-feedback">
          Debe ingresar la región
        </div>
      </div>

      <!-- Ciudad -->
      <div class="col-12 col-md-4">
        <label for="ciudad" class="form-label">Ciudad</label>
        <input type="text" id="ciudad" class="form-control" formControlName="ciudad"
          [ngClass]="{'is-invalid': form.get('ciudad')?.invalid && form.get('ciudad')?.touched}">
        <div class="invalid-feedback">
          Debe ingresar la ciudad
        </div>
      </div>

      <!-- Comuna -->
      <div class="col-12 col-md-4">
        <label for="comuna" class="form-label">Comuna</label>
        <input type="text" id="comuna" class="form-control" formControlName="comuna"
          [ngClass]="{'is-invalid': form.get('comuna')?.invalid && form.get('comuna')?.touched}">
        <div class="invalid-feedback">
          Debe ingresar la comuna
        </div>
      </div>

      <!-- Dirección Comercial -->
      <div class="col-12 col-md-6">
        <label for="direccion_comercial" class="form-label">Dirección Comercial</label>
        <input type="text" id="direccion_comercial" class="form-control" formControlName="direccion_comercial"
          [ngClass]="{'is-invalid': form.get('direccion_comercial')?.invalid && form.get('direccion_comercial')?.touched}">
        <div class="invalid-feedback">
          Debe ingresar la dirección comercial
        </div>
      </div>

      <!-- Correo Electrónico Comercial -->
      <div class="col-12 col-md-6">
        <label for="correo_electronico_comercial" class="form-label">Correo Electrónico Comercial</label>
        <input type="email" id="correo_electronico_comercial" class="form-control" formControlName="correo_electronico_comercial"
          [ngClass]="{'is-invalid': form.get('correo_electronico_comercial')?.invalid && form.get('correo_electronico_comercial')?.touched}">
        <div class="invalid-feedback">
          Debe ingresar un correo electrónico válido
        </div>
      </div>

    </div>

    <!-- SECCIÓN 3: REPRESENTANTE LEGAL -->
    <h6 class="text-primary fw-bold mb-3">Representante Legal</h6>
    <div class="row g-3">

      <!-- Nombre y Apellido -->
      <div class="col-12 col-md-6">
        <label for="nombre_apellido_representante_legal" class="form-label">Nombre y Apellido</label>
        <input type="text" id="nombre_apellido_representante_legal" class="form-control" formControlName="nombre_apellido_representante_legal"
          [ngClass]="{'is-invalid': form.get('nombre_apellido_representante_legal')?.invalid && form.get('nombre_apellido_representante_legal')?.touched}">
        <div class="invalid-feedback">
          Debe ingresar el nombre del representante
        </div>
      </div>

      <!-- RUT Representante Legal -->
      <div class="col-12 col-md-6">
        <label for="rut_representante_legal" class="form-label">RUT Representante Legal</label>
        <input type="text" id="rut_representante_legal" class="form-control" formControlName="rut_representante_legal"
          [ngClass]="{'is-invalid': form.get('rut_representante_legal')?.invalid && form.get('rut_representante_legal')?.touched}">
        <div class="invalid-feedback">
          Debe ingresar el RUT del representante
        </div>
      </div>

      <!-- Correo Representante Legal -->
      <div class="col-12">
        <label for="correo_electronico_representante_legal" class="form-label">Correo Electrónico Representante Legal</label>
        <input type="email" id="correo_electronico_representante_legal" class="form-control" formControlName="correo_electronico_representante_legal"
          [ngClass]="{'is-invalid': form.get('correo_electronico_representante_legal')?.invalid && form.get('correo_electronico_representante_legal')?.touched}">
        <div class="invalid-feedback">
          Debe ingresar un correo electrónico válido
        </div>
      </div>

      <div class="col-12">
        <label for="certificado" class="form-label">Certificado Digital</label>
        <input type="file" id="certificado" class="form-control" (change)="cargarCertificado($event)" accept=".p12,.pfx"
          [ngClass]="{'is-invalid': certificadoError}">
        <div class="invalid-feedback" *ngIf="certificadoError">
          Debe seleccionar un certificado válido
        </div>

      </div>

    </div>

  </form>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-secondary" (click)="activeModal.dismiss('Cancel click')">Cancelar</button>
  <button type="button" class="btn btn-primary"   (click)="guardar()">Guardar</button>
</div>